import { Dialog } from "@mui/material";
import React, { useState } from "react";
// import styles from "../../styles/pages/user/editordashboard/editor-pendingpublication-video-page.module.scss";
import styles from "../../../styles/pages/user/editordashboard/editor-pendingpublication-video-page.module.scss";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import videoPage from "../../../public/assets/images/videoPageImg.png";
import CopyLinkIcon from "../../../public/assets/icons/CopyLinkIcon";
import VideoButtonGroup from "../../../components/VideoButtonGroup/VideoButtonGroup";
import DownloadArrowIcon from "../../../public/assets/icons/DownloadArrowIcon";
import CopyBlueIcon from "../../../public/assets/icons/CopyBlueIcon";
import CrossBlackIcon from "../../../public/assets/icons/CrossBlackIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LinkAddIcon from "../../../ui/Icons/LinkAddIcon";
import RightBlackIcon from "../../../ui/Icons/RightBlackIcon";
import VideoUpbuttonOptionPending from "../../../components/VideoUpbuttonOption/VideoUpbuttonOptionPending";
import BackLinkIcon from "../../../ui/Icons/BackLinkIcon";
import SaveLinkIcon from "../../../ui/Icons/SaveLinkIcon";
import EditLInkIcon from "../../../ui/Icons/EditLInkIcon";
import RoundRightIcon from "../../../ui/Icons/RoundRightIcon";
import { useQuery } from "react-query";
import { editorDashboardVideoDetails } from "../../../api/functions/editorDashboard.api";
import HlsPalyer from "../components/HlsPlayer";
import {
  clipCopy,
  concatDownloadPath,
  concatHostAndVideoPath,
  getUtcDate,
  getUtcTime,
  openInNewTab,
  roleFinder,
} from "../../../lib/functions/utils.lib";
import ApiLoader from "../../Loaders/ApiLoader";

function EditorDashboardVideoModal({ open, onClose, id, className }) {
  const [expanded, setExpanded] = React.useState(false);
  const [saved, setsaved] = useState(false);
  const [linkButton, setlinkButton] = useState({ youtube: false, post: false });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClose = () => {
    setOpen(false);
    setsaved(false);
    setlinkButton(false);
  };
  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => {
      setsaved(true);
    }, 2000);
  };

  const {
    data,
    isLoading: isLoadingGet,
    refetch: refetchVideo,
    isRefetching: isRefetchingVideo,
  } = useQuery(
    ["video_details", id],
    async () => editorDashboardVideoDetails(id),
    {
      enabled: id && open ? true : false,

      /* onSuccess: (data) => {
        // console.warn("data2", data);
        if (data.buyer) {
          setBought(true);
        } else {
          setBought(false);
        }
      }, */
    }
  );

  function tagList(_d) {
    const res = _d.split(",");
    return res.map((item) => {
      return <Button>{item}</Button>;
    });
  }

  console.warn("editorDashboardVideoDetails", data?.data);
  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={className}
      >
        <ApiLoader
          // loading={notesLoading || isLoadingGet || isRefetchingVideo}
          loading={isLoadingGet}
        />
        {data && (
          <Box className={styles.publishVideoPage}>
            <PerfectScrollbar className={styles.editorPublishScroll}>
              <Box className={styles.videoPageMain}>
                <Box className={styles.videoPageMainLeft}>
                  <Box className={styles.videosection}>
                    <Box className={styles.videoSectionvideo}>
                      <HlsPalyer
                        source={concatHostAndVideoPath(
                          data?.data?.converted_url
                        )}
                      />
                    </Box>

                    <Box className={styles.videoLink}>
                      <input
                        type="text"
                        disabled
                        placeholder={concatDownloadPath(data?.data?.video)}
                      />
                      <Button
                        onClick={() =>
                          clipCopy(concatDownloadPath(data?.data?.video))
                        }
                      >
                        <CopyLinkIcon />
                      </Button>
                    </Box>

                    <Box className={styles.videoButtonGroup}>
                      <VideoButtonGroup />
                    </Box>

                    <Box className={styles.downloadVideo}>
                      <Button
                        onClick={() =>
                          openInNewTab(concatDownloadPath(data?.data?.video))
                        }
                      >
                        <DownloadArrowIcon /> Download Video
                      </Button>
                    </Box>
                  </Box>
                  {data?.data?.published === 0 ? (
                    <Box className={styles.publishVideonotification}>
                      <Typography variant="body1">
                        Video Pending Publication{" "}
                        {data?.data?.video_meta?.copywrite_completed_at
                          ? `Since ${getUtcDate(
                              data?.data?.video_meta?.copywrite_completed_at
                            )}${getUtcTime(
                              data?.data?.video_meta?.copywrite_completed_at
                            )}`
                          : null}
                      </Typography>
                    </Box>
                  ) : (
                    ""
                  )}

                  <Box className={styles.submissionDetailsBox}>
                    <Typography variant="h2">Submission Details</Typography>

                    <Box className={styles.submissionVideoBox}>
                      <Box className={styles.submissionDetailsHeader}>
                        <Typography variant="h3">
                          Original Video File (VS Link)
                        </Typography>
                      </Box>
                      <Box className={styles.submissionOriginal}>
                        {data?.data?.original_file_url ? (
                          <>
                            <Typography variant="body1">
                              {data?.data?.original_file_url}
                            </Typography>
                            <Box className={styles.copyIcon}>
                              <Tooltip title="Add" placement="top" arrow={true}>
                                onClick={() => clipCopy(data?.data?.vsid)}
                                <Button
                                  onClick={() =>
                                    clipCopy(data?.data?.original_file_url)
                                  }
                                >
                                  <CopyBlueIcon />
                                </Button>
                              </Tooltip>
                            </Box>
                          </>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>

                    <Box className={styles.submissionWrapBox}>
                      <Box className={styles.submissionWrapSmallBox}>
                        <Box className={styles.submissionVsidBox}>
                          <Box className={styles.submissionDetailsHeader}>
                            <Typography variant="h3">VSID</Typography>
                          </Box>
                          <Box className={styles.submissionOriginal}>
                            {data?.data?.vsid ? (
                              <>
                                <Typography variant="body1">
                                  {data?.data?.vsid}
                                </Typography>
                                <Box className={styles.copyIcon}>
                                  <Tooltip
                                    title="copy"
                                    placement="top"
                                    arrow={true}
                                  >
                                    <Button
                                      onClick={() => clipCopy(data?.data?.vsid)}
                                    >
                                      <CopyBlueIcon />
                                    </Button>
                                  </Tooltip>
                                </Box>
                              </>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles.submissionWrapSmallBox}>
                        <Box className={styles.submissionDateBox}>
                          <Box className={styles.submissionDetailsHeader}>
                            <Typography variant="h3">
                              Submission Date
                            </Typography>
                          </Box>
                          <Box className={styles.submissionOriginal}>
                            {data?.data?.created_at ? (
                              <>
                                <Typography variant="body1">
                                  {data?.data?.created_at
                                    ? `${getUtcDate(
                                        data?.data?.created_at
                                      )}${getUtcTime(data?.data?.created_at)}`
                                    : null}
                                </Typography>
                                <Box className={styles.copyIcon}>
                                  <Tooltip
                                    title="copy"
                                    placement="top"
                                    arrow={true}
                                  >
                                    <Button
                                      onClick={() =>
                                        clipCopy(
                                          `${getUtcDate(
                                            data?.data?.created_at
                                          )}${getUtcTime(
                                            data?.data?.created_at
                                          )}`
                                        )
                                      }
                                    >
                                      <CopyBlueIcon />
                                    </Button>
                                  </Tooltip>
                                </Box>
                              </>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles.submissionWrapSmallBox}>
                        <Box className={styles.submissionShareBox}>
                          <Box className={styles.submissionDetailsHeader}>
                            <Typography variant="h3">Revenue Share</Typography>
                          </Box>
                          <Box className={styles.submissionOriginal}>
                            {data?.data?.video_extra?.revenue_share ? (
                              <>
                                <Typography variant="body1">
                                  {data?.data?.video_extra?.revenue_share}
                                </Typography>
                                <Box className={styles.copyIcon}>
                                  <Tooltip
                                    title="copy"
                                    placement="top"
                                    arrow={true}
                                  >
                                    <Button
                                      onClick={() =>
                                        clipCopy(
                                          data?.data?.video_extra?.revenue_share
                                        )
                                      }
                                    >
                                      <CopyBlueIcon />
                                    </Button>
                                  </Tooltip>
                                </Box>
                              </>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Box>
                      </Box>

                      <Box className={styles.submissionWrapSmallBox}>
                        <Box className={styles.submissionAcquiBox}>
                          <Box className={styles.submissionDetailsHeader}>
                            <Typography variant="h3">Acquisitor</Typography>
                          </Box>
                          <Box className={styles.submissionOriginal}>
                            {data?.data?.user?.name ? (
                              <>
                                <Typography variant="body1">
                                  {data?.data?.user?.name
                                    ? `${data?.data?.user?.name}`
                                    : ""}
                                  <span className={styles.table_customer}>
                                    {data?.data.user?.role?.id
                                      ? ` (${roleFinder(
                                          data?.data.user?.role?.id
                                        )})`
                                      : ""}
                                  </span>
                                </Typography>
                                <Box className={styles.copyIcon}>
                                  <Tooltip
                                    title="copy"
                                    placement="top"
                                    arrow={true}
                                  >
                                    <Button
                                      onClick={() =>
                                        clipCopy(
                                          `${
                                            data?.data?.user?.name
                                          } (${roleFinder(
                                            data?.data.user?.role?.id
                                          )})`
                                        )
                                      }
                                    >
                                      <CopyBlueIcon />
                                    </Button>
                                  </Tooltip>
                                </Box>
                              </>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box className={styles.videoPageMainRight}>
                  <Box className={styles.teamNotesBox}>
                    <Typography variant="h3">Team Notes</Typography>
                    <Typography variant="body1">
                      {data?.data?.video_extra?.team_note ?? ""}
                    </Typography>
                    <Button onClick={() => onClose()}>
                      <CrossBlackIcon />
                    </Button>
                  </Box>

                  <Box className={styles.videoPageAccordian}>
                    <Accordion
                      expanded={expanded === "panel1"}
                      onChange={handleChange("panel1")}
                      disabled
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Box className={styles.accordianHeading}>
                          <Typography variant="body1">Team Messages</Typography>
                        </Box>
                        <Box className={styles.accordianButtonGrp}>
                          <Button>Admin</Button>
                          <Button>QC Agent</Button>
                          <Button>Copywriter</Button>
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          Nulla facilisi. Phasellus sollicitudin nulla et quam
                          mattis feugiat. Aliquam eget maximus est, id dignissim
                          quam.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </Box>

                  <Box className={styles.videoMetaData}>
                    <Typography variant="h3">Video Metadata</Typography>

                    <Box
                      className={`${styles.titleBox} ${styles.titleBoxActive}`}
                    >
                      <Typography variant="h4">Title</Typography>
                      {data?.data?.video_meta?.new_title ? (
                        <Typography variant="body1">
                          {data?.data?.video_meta?.new_title}
                          <Tooltip title="copy" placement="top" arrow={true}>
                            <Button
                              onClick={() =>
                                clipCopy(data?.data?.video_meta?.new_title)
                              }
                            >
                              <CopyBlueIcon />
                            </Button>
                          </Tooltip>
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Box>

                    <Box
                      className={`${styles.descriptionBox} ${styles.descriptionBoxActive}`}
                    >
                      <Typography variant="h4">Description</Typography>
                      {data?.data?.video_meta?.new_description ? (
                        <Typography variant="body1">
                          {data?.data?.video_meta?.new_description}
                          <Tooltip title="copy" placement="top" arrow={true}>
                            <Button
                              onClick={() =>
                                clipCopy(
                                  data?.data?.video_meta?.new_description
                                )
                              }
                            >
                              <CopyBlueIcon />
                            </Button>
                          </Tooltip>
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Box>

                    <Box className={`${styles.tagBox} ${styles.tagBoxActive}`}>
                      <Typography variant="h4">Tags</Typography>
                      <Box className={styles.tagButton}>
                        {tagList(data?.data?.video_meta?.tags)}
                        <Tooltip title="copy" placement="top" arrow={true}>
                          <Button>
                            <CopyBlueIcon
                              onClick={() =>
                                clipCopy(data?.data?.video_meta?.tags)
                              }
                            />
                          </Button>
                        </Tooltip>
                      </Box>
                    </Box>

                    <Box className={styles.filmingWrapMain}>
                      <Box className={styles.filmingWrap}>
                        <Box className={styles.filmingLocationBox}>
                          <Typography variant="h4">Filming Location</Typography>
                          {data?.data?.city ||
                          data?.data?.country ||
                          data?.data?.state ? (
                            <Typography variant="body1">
                              {`${data?.data?.city ?? ""} ${
                                data?.data?.state ?? ""
                              }  ${data?.data?.country ?? ""}`}{" "}
                              <Tooltip
                                title="copy"
                                placement="top"
                                arrow={true}
                              >
                                <Button
                                  onClick={() =>
                                    clipCopy(
                                      `${data?.data?.city ?? ""} ${
                                        data?.data?.state ?? ""
                                      }  ${data?.data?.country ?? ""}`
                                    )
                                  }
                                >
                                  <CopyBlueIcon />
                                </Button>
                              </Tooltip>
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>

                      <Box className={styles.filmingWrap}>
                        <Box className={styles.filmingDateBox}>
                          <Typography variant="h4">Filming Date</Typography>
                          {data?.data?.when_filmed ? (
                            <Typography variant="body1">
                              {getUtcDate(data?.data?.when_filmed)}
                              <Tooltip
                                title="copy"
                                placement="top"
                                arrow={true}
                              >
                                <Button
                                  onClick={() =>
                                    clipCopy(
                                      getUtcDate(data?.data?.when_filmed)
                                    )
                                  }
                                >
                                  <CopyBlueIcon />
                                </Button>
                              </Tooltip>
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box className={styles.clientDetails}>
                    <Typography variant="h3">Client Details</Typography>

                    <Box className={styles.clientWrapMain}>
                      <Box className={styles.clientWrap}>
                        <Box
                          className={`${styles.clientLocationBox} ${styles.fullName}`}
                        >
                          <Typography variant="h4">Full Name</Typography>
                          {data?.data?.first_name ? (
                            <Typography variant="body1">
                              {data?.data?.first_name
                                ? `${data?.data?.first_name} ${data?.data?.last_name}`
                                : ""}{" "}
                              <Tooltip
                                title="copy"
                                placement="top"
                                arrow={true}
                              >
                                <Button
                                  onClick={() =>
                                    clipCopy(
                                      `${data?.data?.first_name} ${data?.data?.last_name}`
                                    )
                                  }
                                >
                                  <CopyBlueIcon />
                                </Button>
                              </Tooltip>
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>

                      <Box className={styles.clientWrap}>
                        <Box
                          className={`${styles.clientLocationBox} ${styles.emailAddress}`}
                        >
                          <Typography variant="h4">Email Address</Typography>
                          {data?.data?.email ? (
                            <Typography variant="body1">
                              {data?.data?.email}{" "}
                              <Tooltip
                                title="copy"
                                placement="top"
                                arrow={true}
                              >
                                <Button
                                  onClick={() => clipCopy(data?.data?.email)}
                                >
                                  <CopyBlueIcon />
                                </Button>
                              </Tooltip>
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>

                      <Box className={styles.clientWrap}>
                        <Box
                          className={`${styles.clientLocationBox} ${styles.mediaCredit}`}
                        >
                          <Typography variant="h4">Media Credit</Typography>
                          {data?.data?.video_credit ? (
                            <Typography variant="body1">
                              {data?.data?.video_credit}{" "}
                              <Tooltip
                                title="copy"
                                placement="top"
                                arrow={true}
                              >
                                <Button
                                  onClick={() =>
                                    clipCopy(data?.data?.video_credit)
                                  }
                                >
                                  <CopyBlueIcon />
                                </Button>
                              </Tooltip>
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box className={styles.uploadDetails}>
                    <Typography variant="h3">Upload Details</Typography>

                    <Box className={styles.uploadLinks}>
                      <Box className={styles.youtubeLink}>
                        <Box className={styles.youtubeLinkHeader}>
                          <Typography variant="h4">YouTube Post URL</Typography>
                          <Stack direction={"row"} className={styles.linkEdit}>
                            {linkButton.youtube ? (
                              <Stack direction={"row"}>
                                <Button>
                                  <BackLinkIcon />
                                </Button>
                                <Button
                                  onClick={() =>
                                    setlinkButton({
                                      ...linkButton,
                                      youtube: false,
                                    })
                                  }
                                >
                                  <SaveLinkIcon />
                                </Button>
                              </Stack>
                            ) : (
                              <Button
                                onClick={() =>
                                  setlinkButton({
                                    ...linkButton,
                                    youtube: true,
                                  })
                                }
                              >
                                <EditLInkIcon />
                              </Button>
                            )}
                          </Stack>
                        </Box>
                        <Box className={styles.youtubeLinkError}>
                          <input
                            type=""
                            placeholder="https://www.youtube.com/watch?v=sgf_G_Kv6zo"
                          />
                          <Typography variant="body1">
                            The URL you entered is not a valid YouTube URL
                          </Typography>
                        </Box>
                      </Box>

                      <Box className={styles.addedDate}>
                        <Typography variant="h4">Added On</Typography>
                        <input
                          type=""
                          placeholder="September 30, 2023 at 03:24:04 PM UTC"
                        />
                      </Box>
                    </Box>

                    <Box className={styles.uploadLinks}>
                      <Box className={styles.youtubeLink}>
                        <Box className={styles.youtubeLinkHeader}>
                          <Typography variant="h4">Post URL</Typography>
                          <Stack direction={"row"} className={styles.linkEdit}>
                            {linkButton.post ? (
                              <Stack direction={"row"}>
                                <Button>
                                  <BackLinkIcon />
                                </Button>
                                <Button
                                  onClick={() =>
                                    setlinkButton({
                                      ...linkButton,
                                      post: false,
                                    })
                                  }
                                >
                                  <SaveLinkIcon />
                                </Button>
                              </Stack>
                            ) : (
                              <Button
                                onClick={() =>
                                  setlinkButton({ ...linkButton, post: true })
                                }
                              >
                                <EditLInkIcon />
                              </Button>
                            )}
                          </Stack>
                        </Box>
                        <input
                          type=""
                          placeholder="https://www.youtube.com/watch?v=sgf_G_Kv6zo"
                        />
                      </Box>

                      <Box className={styles.addedDate}>
                        <Typography variant="h4">Added On</Typography>
                        <input
                          type=""
                          placeholder="September 30, 2023 at 03:24:04 PM UTC"
                        />
                      </Box>
                    </Box>

                    <Box className={styles.linkAddButton}>
                      <Button>
                        <LinkAddIcon /> Add another URL
                      </Button>
                    </Box>

                    <Box className={styles.saveBtnGrp}>
                      <Button
                        className={`${styles.saveBtnGrpInactive} ${styles.saveBtnGrpActive}`}
                      >
                        <RoundRightIcon /> Mark as Complete
                      </Button>
                      <Button className={styles.cancelBtn}>Cancel</Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </PerfectScrollbar>
          </Box>
        )}
      </Dialog>
    </>
  );
}

export default EditorDashboardVideoModal;
